import React from 'react';
import { image } from '../../../../utils/data/baseUrl';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import classNames from 'classnames';
import Picture from '../../../baseComponents/gui/picture/Picture';

const RulesImage = React.forwardRef(function ({ bg, img, type, picture, activeSlide }, ref) {
  return (
    <div className={'rules__image-container'}>
      <SwitchTransition>
        <CSSTransition key={activeSlide} timeout={{ enter: 300, exit: 300 }} classNames={'rules__image'}>
          <div className={classNames('rules__image', { [`rules__image_${type}`]: type })}>
            <div className={'rules__image-img'}>
              {bg && <img src={image(bg)} alt={'bg'} className={'rules__image-bg'} />}
              {img && <img src={image(img)} alt={'rules-image'} />}
              {picture && <Picture {...picture} />}
            </div>
          </div>
        </CSSTransition>
      </SwitchTransition>
    </div>
  );
});
export default RulesImage;
RulesImage.propTypes = {};
